<template>
    <div class="Create alignment">

      <template>
        <v-flex xs12 sm12>
          <h3 v-if="edit" class="styleHeader">Mappatura Operatore/Procedura - Modifica</h3>
          <h3 v-else class="styleHeader">Mappatura Operatore/Procedura - Aggiungi</h3>
            <v-card class="styleDataTable">
              <form>
              <v-layout>
                <v-autocomplete
                  v-model="Procedure"
                  label="Procedure"
                  required
                  :items="Procedures"
                  :error-messages="ProcedureError"
                  item-text="name"
                  item-value="id"
                  @blur="$v.Procedure.$touch()"
                ></v-autocomplete>
                <v-autocomplete
                  v-model="Operator"
                  label="Operatori"
                  required
                  :items="Operators"
                  :error-messages="OperatorErrors"
                  item-text="fullname"
                  item-value="id"              
                  @blur="$v.Operator.$touch()"
                ></v-autocomplete>
              </v-layout>
              </form>
          </v-card>
        </v-flex>
        <v-btn 
          class="white--text styleButtonTop styleAlignementSaveButton"
          @click="creatingMapping()"
          color="#5c6366">
          <v-icon left>check_circle</v-icon>
            Salva 
          </v-btn>
          <v-btn 
          class="styleButtonTop"
          @click="back()">
          <v-icon left>remove_circle</v-icon>
          Annulla
        </v-btn>
              
      <v-alert :value="errorAlert" type="error" transition="scale-transition">{{ errorMessage }}</v-alert>
    </template>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, maxLength } from "vuelidate/lib/validators";
import debounce from "debounce";
import router from "@/router/index.js";
import operatorsProceduresApi from "../../apiLogisticsTool/operatorsProceduresApi.js";
import operatorsApi from "../../apiLogisticsTool/operatorsApi.js";
import proceduresApi from "../../apiLogisticsTool/proceduresApi.js";
import { error } from 'util';

export default {
  mixins: [validationMixin],

  validations: {
    Operator: { required, maxLength: maxLength(50) },
    Procedure: { required, maxLength: maxLength(50) }
  },

  data: () => ({
    Id: 0,
    Operator: "",
    Operators: [],
    Procedure: "",
    Procedures: [],
    errorAlert: false,
    errorMessage: "",
    refreshMenu: ""
  }),

  computed: {
    edit() {
      return this.$route.params.Id > 0;
    },
    ProcedureError() {
      const errors = [];
      if (!this.$v.Procedure.$dirty) return errors;
      !this.$v.Procedure.required && errors.push("Committente Richiesto");
      return errors;
    },
    OperatorErrors() {
      const errors = [];
      if (!this.$v.Operator.$dirty) return errors;
      !this.$v.Operator.required && errors.push("Utente Richiesto");
      return errors;
    }
  },

  created() {
    const Id = this.$route.params.Id;
    
    if (Id) {
      //chiamo la get e l'autocomplete
      operatorsProceduresApi.GetOperatorProcedure(Id).then(response => {
        this.Operator = response.data.operatorId;
        this.Procedure = response.data.procedureId;
      })
    }

    //chiamo la get operations e la get procedures per prendermi i dati da salvare nell'array ?
    operatorsApi.GetOperators().then(response => {
      
      this.Operators = response.data;
    });

    proceduresApi.GetProcedures().then(response => {
      
      this.Procedures = response.data;
    });
  },

  methods: {

    creatingMapping() {
      this.$v.$touch();
      const Id = this.$route.params.Id;

      if (this.$v.Operator.$error || this.$v.Procedure.$error) {
        console.log("Errors found");
        return;
      }

      let OperatorProcedure = {
        Id: Id,
        OperatorId: this.Operator,
        ProcedureId: this.Procedure
      };

      if (Id) {
        //è una modifica
        operatorsProceduresApi
          .UpdateOperatorProcedure(OperatorProcedure)
          .then(() => {
            this.$emit("refreshMenu", this.refreshMenu);
            router.push("/OperatorsProcedures/Index");
          })
          .catch(error => {
            console.log("error update: " + error);
            this.errorAlert = true;
            this.errorMessage = error.response.data;
          });
      } else {
        //è una nuova mappatura
        operatorsProceduresApi
          .InsertOperatorProcedure(OperatorProcedure)
          .then(response => {
            this.$emit("refreshMenu", this.refreshMenu);
            router.push("/OperatorsProcedures/Index");
          })
          .catch(error => {
            console.log("error insert: " + error);
            this.errorAlert = true;
            this.errorMessage = error.response.data;
          });
      }
    },

    back() {
      router.push("/OperatorsProcedures/Index");
    },

    clear() {
      if (this.$route.params.Id) {
        this.$v.$reset();
        this.Procedure = "";
        errorAlert = false;
      } else {
        this.$v.$reset();
        this.Operator = "";
        this.Procedure = "";
        errorAlert = false;
      }
    }
  }
};
</script>
